import { Statistic } from '@indigo-ag/component-module';
import { Lawsuit } from '@indigo-ag/schema';
import i18next from 'i18next';
import React from 'react';
import styled from 'styled-components';

import { currency } from 'shared';
import { LawsuitsTable } from './LawsuitsTable';

const EMPTY_VALUE = '-';

const NoResultsContainer = styled.div`
  margin: 32px;
`;

const StatContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin: 20px 0;
`;

interface Props {
  lawsuits?: Lawsuit[] | null;
  lawsuitsCount?: number | null;
  lawsuitsTotal?: number | null;
}

export const LawsuitsContent = ({ lawsuits, lawsuitsCount, lawsuitsTotal }: Props) => {
  if (!lawsuits) {
    return <NoResultsContainer>{i18next.t('couldntFetchData')}</NoResultsContainer>;
  }

  return (
    <>
      <StatContainer>
        <Statistic
          value={lawsuitsCount != null ? lawsuitsCount.toString() : EMPTY_VALUE}
          label={i18next.t('consultationsCard_passiveLawsuits')}
        />
        <Statistic
          value={lawsuitsTotal != null ? currency.formatBrazilCurrency(lawsuitsTotal) : EMPTY_VALUE}
          label={i18next.t('consultationsCard_value')}
        />
      </StatContainer>
      {!!lawsuitsCount && <LawsuitsTable lawsuits={lawsuits} />}
    </>
  );
};
